import React from 'react';
import { StickyBar } from '../components/StickyBar';
import { HeroSection } from '../components/HeroSection';
import { MirrorReality } from '../components/MirrorReality';
import { CortisolReveal } from '../components/CortisolReveal';
import { OfferStack } from '../components/OfferStack';
import { PreBabyJeans } from '../components/PreBabyJeans';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-body text-brand-charcoal selection:bg-brand-sage/30" data-id="element-181">
      <StickyBar data-id="element-182" />
      <main data-id="element-183">
        <HeroSection data-id="element-184" />
        <MirrorReality data-id="element-185" />
        <CortisolReveal data-id="element-186" />
        <OfferStack data-id="element-187" />
        <PreBabyJeans data-id="element-188" />
        <PricingSection data-id="element-189" />
      </main>
      <Footer data-id="element-190" />
    </div>;
}